import styled from '@emotion/styled';
import { useIsMobile } from '@stores/AppCommonData';
import { mediaQuery, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import Accordion from 'aquilla/core/molecules/Accordion';
import React, { forwardRef } from 'react';
import { BlockTypeToLabel } from './constants';

const Container = styled.div`
  margin-top: ${Spacings.SPACING_14B};
  ${mediaQuery.uptoMobile} {
    margin-top: 0;
    border-bottom: 1px solid var(--color-i-divider);
  }
`;

const Title = styled(Typography)`
  margin-bottom: ${Spacings.SPACING_6B};
  ${mediaQuery.uptoMobile} {
    padding: ${Spacings.SPACING_3B} ${Spacings.SPACING_0B};
    margin-bottom: ${Spacings.SPACING_0B};
  }
`;

const FAQsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledAccordion = styled(Accordion)`
  margin-bottom: ${Spacings.SPACING_4B};
  & > .aquilla-accordion-header > .accordion-header-title {
    white-space: normal;
  }
  ${mediaQuery.uptoMobile} {
    border: 0px;
    padding: ${Spacings.SPACING_2B} ${Spacings.SPACING_0B};
    margin-bottom: ${Spacings.SPACING_2B};
  }
`;

const FAQSection = forwardRef((props, ref) => {
  const isMobile = useIsMobile();
  const { data, type } = props;
  const name = BlockTypeToLabel[type];

  return (
    <Container ref={ref}>
      <Title variant={isMobile ? 'h5' : 'h4'}>{name}</Title>
      <FAQsWrapper>
        {data?.map(({ uid, question, answer }) => {
          return (
            <StyledAccordion
              key={uid}
              title={
                <Typography variant={isMobile ? 'h6' : 'h5'}>
                  {question}
                </Typography>
              }
            >
              {answer}
            </StyledAccordion>
          );
        })}
      </FAQsWrapper>
    </Container>
  );
});

FAQSection.displayName = 'FAQ Section';

export default React.memo(FAQSection);
